export const formatPrice = (price?: number, decimals: number = 2) => {
  if (!price) {
    return "-";
  } else if (price === 0) {
    return "0";
  } else {
    return new Intl.NumberFormat("sv-SE", {
      style: "decimal",
      useGrouping: true,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(price);
  }
};

export const formatAmountWithCurrency = (
  amount: number,
  currencyCode: string,
  decimals: number = 0,
) => `${amount ? formatPrice(amount, decimals) : "0"} ${currencyCode}`;

export const getCurrencySymbol = (
  currencyCode?: string | null,
): string | undefined => {
  if (!currencyCode) return undefined;
  try {
    const parts = new Intl.NumberFormat("sv-SE", {
      style: "currency",
      currency: currencyCode,
    }).formatToParts(0);
    return parts.find((part) => part.type === "currency")?.value;
  } catch {
    return undefined;
  }
};
